import React from 'react';
export function CostComparison() {
  const data = [{
    sin: 'No structure for daily brain training',
    costo: 'Attention gap widens every week'
  }, {
    sin: 'No plan for reducing screen time',
    costo: 'Daily battles that drain everyone'
  }, {
    sin: 'No tools to build focus at home',
    costo: 'Child falls further behind at school'
  }, {
    sin: 'No strategy for emotional regulation',
    costo: 'Meltdowns before every homework session'
  }, {
    sin: 'No progression system',
    costo: 'Child quits every activity before finishing'
  }, {
    sin: 'Feeling helpless as a parent',
    costo: 'The heaviest cost of all'
  }];
  return <section className="bg-cream py-16 px-4 border-t border-border" data-id="element-36">
      <div className="max-w-4xl mx-auto" data-id="element-37">
        <h2 className="text-3xl md:text-5xl font-heading font-black text-center text-white mb-10" data-id="element-38">
          ⚖️ THE REAL COST OF NOT HAVING IT
        </h2>

        <div className="bg-navy rounded-3xl overflow-hidden border border-white/10 shadow-md mb-10" data-id="element-39">
          <div className="grid grid-cols-2 bg-black/20 border-b border-white/10" data-id="element-40">
            <div className="p-6 text-center font-heading font-bold text-white text-base md:text-lg" data-id="element-41">
              Without Kit The Focused Mindset™
            </div>
            <div className="p-6 text-center font-heading font-bold text-base md:text-lg text-softred" data-id="element-42">
              The Real Cost
            </div>
          </div>
          <div className="divide-y divide-border" data-id="element-43">
            {data.map((row, i) => <div key={i} className="grid grid-cols-2 hover:bg-white/5 transition-colors" data-id="element-44">
                <div className="p-6 text-ink flex items-center justify-center text-center text-sm md:text-base font-medium" data-id="element-45">
                  {row.sin}
                </div>
                <div className="p-6 font-bold flex items-center justify-center text-center bg-softred/10 text-softred text-sm md:text-base" data-id="element-46">
                  {row.costo}
                </div>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-47">
          <p className="text-2xl md:text-4xl font-heading font-bold text-white italic" data-id="element-48">
            The next 10 minutes of your child's day can be completely different.
          </p>
        </div>
      </div>
    </section>;
}